import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mountain, Calendar, Trophy, Camera, ShoppingBag, Menu, X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Layout = ({ children }) => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [storeEnabled, setStoreEnabled] = useState(true);

  useEffect(() => {
    // Fetch site settings to check if store is enabled
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/settings`);
        setStoreEnabled(response.data.store_enabled);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  const allNavItems = [
    { path: '/', label: 'Início', icon: Mountain },
    { path: '/events', label: 'Eventos', icon: Calendar },
    { path: '/results', label: 'Resultados', icon: Trophy },
    { path: '/gallery', label: 'Galeria', icon: Camera },
    { path: '/store', label: 'Loja', icon: ShoppingBag },
  ];

  // Filter nav items based on store status
  const navItems = allNavItems.filter(item => {
    if (item.path === '/store' && !storeEnabled) return false;
    return true;
  });

  return (
    <div className="min-h-screen flex flex-col">
      <header data-testid="header" className="sticky top-0 z-50 backdrop-blur-md bg-white/70 border-b border-white/20 shadow-sm">
        <nav className="px-6 md:px-12 lg:px-24 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
              <Mountain className="w-8 h-8 text-primary" strokeWidth={2.5} />
              <span className="text-2xl font-heading font-black tracking-tighter uppercase text-primary">
                4sEventos
              </span>
            </Link>

            <button
              data-testid="mobile-menu-toggle"
              className="md:hidden text-primary"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            <div className="hidden md:flex items-center gap-8">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    data-testid={`nav-${item.label.toLowerCase()}`}
                    className={`flex items-center gap-2 text-sm font-bold uppercase tracking-widest transition-colors ${
                      isActive ? 'text-accent' : 'text-primary hover:text-accent'
                    }`}
                  >
                    <Icon className="w-4 h-4" />
                    {item.label}
                  </Link>
                );
              })}
            </div>
          </div>

          {mobileMenuOpen && (
            <div data-testid="mobile-menu" className="md:hidden mt-4 pb-4 space-y-4">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                    onClick={() => setMobileMenuOpen(false)}
                    className={`flex items-center gap-3 text-base font-bold uppercase tracking-widest transition-colors ${
                      isActive ? 'text-accent' : 'text-primary hover:text-accent'
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    {item.label}
                  </Link>
                );
              })}
            </div>
          )}
        </nav>
      </header>

      <main className="flex-1">{children}</main>

      <footer data-testid="footer" className="bg-primary text-primary-foreground py-12">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-heading font-bold uppercase mb-4">4sEventos</h3>
              <p className="text-sm leading-relaxed opacity-90">
                Organizando as melhores corridas.
              </p>
            </div>
            <div>
              <h4 className="text-sm font-heading font-bold uppercase mb-4 tracking-widest">Contato</h4>
              <p className="text-sm opacity-90">Email: contato@maxx4seventos.com.br</p>
              <p className="text-sm opacity-90">Tel: (35) 99995 0547</p>
            </div>
            <div>
              <h4 className="text-sm font-heading font-bold uppercase mb-4 tracking-widest">Siga-nos</h4>
              <p className="text-sm opacity-90">Instagram: <a href="https://www.instagram.com/copa_terras_altas/" target="_blank">@copa_terras_altas</a></p>
              <p className="text-sm opacity-90">Facebook: <a href="https://www.facebook.com/terrasaltasmtb/?locale=pt_BR" target="_blank">terrasaltasmtb</a></p>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-white/20 text-center text-sm opacity-75">
            © 2026 4sEventos. Todos os direitos reservados.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
